/**
 * These constants are purposefully placed in a separate module from the CoauthorGallery to
 * prevent pulling the component code into the main slice
 */
export const CoauthorGalleryID = 'CoauthorGallery';

export const facepileMemberClass = 'facePileMember';
